import React, { useState, memo } from 'react';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import { resetFilter } from '../../actions/environment';
import { translate, prefix, removeLanguagePrefix } from '../../utils/locale';
import { titleCase, sentenceCase } from '../../utils/string';
import s from './Breadcrumbs.scss';

const areEqual = (prevProps, { pageStatus, pageData, productCache, setup, location }) => {
	if (pageStatus.loading) return true;
	if (!productCache[setup.market] || !productCache[setup.market][setup.pricelist]) return true;
	const currentPath = removeLanguagePrefix(location.pathname);
	if (location.type !== 'SELECTION' && !pageData[currentPath]) return true;

	return false;
};

const Breadcrumbs = ({ pageData, location, filter, product = '', productCache, setup, placeholder, ...props }) => {
	const filtering = productCache[setup.market] && productCache[setup.market][setup.pricelist];
	const currentPath = removeLanguagePrefix(location.pathname);
	const data = pageData[currentPath];

	if (!filtering || !data) return null;

	const pathSections = currentPath.split('/');
	const isLocalized = filtering.localized[setup.language];
	const categoryTitles = isLocalized ? Object.keys(filtering.filterArrays.categories).reduce((acc, cat) => {
		const categoryKey = isLocalized.categories[cat] ? isLocalized.categories[cat].key : cat;
		const categoryDescription = isLocalized.categories[cat] ? isLocalized.categories[cat].description : filtering.filterDescriptions.categories[cat];
		return ({ ...acc, [categoryKey]: categoryDescription });
	}, {}) : filtering.filterDescriptions.categories;

	const resetFilterHandler = () => {
		props.resetFilter();
	};

	return (
		<div className={[s.breadcrumbs, (product ? s.breadcrumbs__productPage : null), (placeholder ? s.breadcrumbs__placeholder : null), (location.type === 'SELECTION' ? s.breadcrumbs__selection : null)].join(' ')}>
			<div className={s.breadcrumbs_inner}>
				<div className={s.breadcrumbs_inner_links}>
					{ data?.baseType !== 'categories' && !product && <Link className={s.breadcrumbs_inner_link} to={prefix(setup, '/')}><span>{ translate(setup, 'home') }</span></Link> }
					{
						data?.baseType === 'categories' && pathSections.map((uri, i) => {
							const breadcrumbPath = pathSections.reduce((acc, path, j) => (i >= j ? `${acc}/${path}` : acc), '').slice(1);
							let title = '';

							if (data.baseType === 'brands' && translate(setup, 'designersUri', 'listings').text === uri) {
								title = translate(setup, 'designersTitle', 'listings');
							} else if ((i === pathSections.length - 1 || i === 0) && translate(setup, 'filterNewUri') === uri) {
								title = translate(setup, 'filterNew');
							} else if ((i === pathSections.length - 1 || i === 0) && translate(setup, 'filterSaleUri') === uri) {
								title = translate(setup, 'filterSale');
							} else if (data.baseType === 'brands' && i === 1) {
								title = filtering.filterDescriptions.brands[uri] ? filtering.filterDescriptions.brands[uri] : titleCase(uri);
							} else if (data.baseType === 'brands' && i > 1) {
								title = categoryTitles[breadcrumbPath.split('/').slice(2).join('/')];
							} else if (categoryTitles[breadcrumbPath]) {
								title = categoryTitles[breadcrumbPath];
							}

							if (!title) return null;

							return <Link key={breadcrumbPath} className={s.breadcrumbs_inner_link} onClick={resetFilterHandler} to={prefix(setup, breadcrumbPath)}><span>{ title }</span></Link>;
						})
					}
					{
						data?.baseType !== 'categories' && pathSections.length > 1 && pathSections.slice(0, -1).map((page, i) => {
							const breadcrumbPath = pathSections.reduce((acc, path, j) => (i >= j ? `${acc}/${path}` : acc), '').slice(1);

							return <Link key={breadcrumbPath} className={s.breadcrumbs_inner_link} to={prefix(setup, breadcrumbPath)}><span>{ sentenceCase(page) }</span></Link>;
						})
					}
					{
						data?.content?.meta?.default && <span className={s.breadcrumbs_inner_link}>{ translate(setup, data.content.meta.default.title) }</span>
					}
					{
						product && <span className={s.breadcrumbs_inner_link}>{ product }</span>
					}
				</div>
			</div>
		</div>
	);
};

const mapState = ({ pageStatus, pageData, location, environment, productCache, filter }) => ({
	pageStatus,
	pageData,
	location,
	setup: environment.setup,
	productCache,
	filter,
});

export default hot(module)(connect(mapState, { resetFilter })(memo(Breadcrumbs, areEqual)));
